import { PillPropsType } from '@astro-ui/components/Pill'
import { HomeTabStatusType } from '../@types/homeTab'

/** `status` query param on GET /browse/internal/v1/homepage-tabbings */
export const HOME_TAB_STATUS = {
  DRAFT: 1,
  ACTIVE: 2,
  SCHEDULED: 3,
  ENDED: 4,
  INACTIVE: 5,
} as const

/** `homepage_tabbing_type_id` query param on GET /browse/internal/v1/homepage-tabbings */
export const HOME_TAB_TYPE = {
  CATEGORY: 1,
  SEASONAL: 2,
  CAMPAIGN: 3,
  DEMAND_EXPANSION: 4,
} as const

export const HOME_TAB_STATUS_NAME: Record<number, HomeTabStatusType> = {
  [HOME_TAB_STATUS.DRAFT]: 'Draft',
  [HOME_TAB_STATUS.ACTIVE]: 'Active',
  [HOME_TAB_STATUS.SCHEDULED]: 'Scheduled',
  [HOME_TAB_STATUS.ENDED]: 'Ended',
  [HOME_TAB_STATUS.INACTIVE]: 'Inactive',
}

export const HOME_TAB_TYPE_NAME: Record<number, string> = {
  [HOME_TAB_TYPE.CATEGORY]: 'Category',
  [HOME_TAB_TYPE.SEASONAL]: 'Seasonal',
  [HOME_TAB_TYPE.CAMPAIGN]: 'Campaign',
  [HOME_TAB_TYPE.DEMAND_EXPANSION]: 'Demand Expansion',
}

const toSelectOptions = (source: Record<number, string>) =>
  Object.entries(source).map(([value, name]) => ({ name, value }))

export const STATUS_OPTIONS = toSelectOptions(HOME_TAB_STATUS_NAME)

export const TYPE_OPTIONS = toSelectOptions(HOME_TAB_TYPE_NAME)

const STATUS_PILL_THEME: Record<HomeTabStatusType, PillPropsType['theme']> = {
  Active: 'success',
  Scheduled: 'info',
  Ended: 'danger',
  Draft: 'secondary',
  Inactive: 'warning',
}

export const getHomeTabStatusPillColor = (status: HomeTabStatusType): PillPropsType['theme'] =>
  STATUS_PILL_THEME[status] || 'secondary'
